import React from 'react'
import Button from 'react-bootstrap/Button'
import BoxOfficeModal from './BoxOfficeModal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCashRegister } from '@fortawesome/free-solid-svg-icons'
import { showModal } from '../../redux/ui/actions'
import { useDispatch, useSelector } from 'react-redux'
import { isEventAdmin } from '../../redux/state'

export const BoxOfficeButton = props => {
  const dispatch = useDispatch()

  const { variant, id, mode, className, size } = props

  const authorised = useSelector(state => isEventAdmin(state, id))

  if (!authorised) return null

  const handleClick = e => {
    e.stopPropagation()
    dispatch(showModal('boxoffice-events', id, true))
    if (props.handleClick) {
      props.handleClick(e)
    }
  }

  const label = 'Box Office'

  if (mode === 'icon') {
    return (
      <React.Fragment>
        <button
          title={label}
          onClick={handleClick}
          className={className}>
          <FontAwesomeIcon icon={faCashRegister} />
        </button>
        <BoxOfficeModal
          id={id}
          resource="events"
        />{' '}
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <Button
        variant={variant || 'light'}
        title={label}
        onClick={handleClick}
        className={className}
        size={size}>
        <FontAwesomeIcon
          icon={faCashRegister}
          className="me-2"
        />
        <span className="text-nowrap">{label}</span>
      </Button>
      <BoxOfficeModal
        id={id}
        resource="events"
      />{' '}
    </React.Fragment>
  )
}

export default BoxOfficeButton
